<template>
    <div class="grid grid--padding">
        <div class="error-page">
            <div v-if="error500" class="error-page__title">{{ $t('error-page.error-500-text') }}</div>
            <div v-else class="error-page__title">{{ $t('error-page.error-404-text') }}</div>
            <img src="@/assets/images/not-found.svg" :alt="$t('error-page.image-alt')" class="error-page__img" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundView',
    props: {
        error500: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>
